import InformacionIcon from "../../../assets/images/generico/InformacionIcon";
import "./TurnoNoEncontrado.css";

const TurnoNoEncontrado = ({
  loadingState,
  state,
  texto,
  fecha,
  recomendacion,
  txtBtn,
  onClickTurnos,
  excedeBusqueda,
  excedeBusqMsj,
  showBtn,
}) => {
  return (
    <>
      {loadingState.loading ? (
        ""
      ) : (
        <>
          {state !== undefined ? (
            state?.length <= 0 ? (
              <div className="ptur-turnoNoEncontrado-noEcontrados-container">
                <div className="ptur-turnoNoEncontrado-noEcontrados-icono">
                  <InformacionIcon />
                </div>
                <div className="ptur-turnoNoEncontrado-noEcontrados-texto">
                  <div className="ptur-turnoNoEncontrado-noEcontrados-texto">
                    {!excedeBusqueda ? (
                      <span>
                        <p className="rb18b">
                          {texto}
                          {fecha}
                        </p>
                        <p
                          className="rb16l"
                          dangerouslySetInnerHTML={{
                            __html: recomendacion,
                          }}
                        ></p>
                      </span>
                    ) : (
                      <span>
                        <p className="rb18b">{excedeBusqMsj}</p>
                        {/* <p className="rb16l">{excedeBusqMsj}</p> */}
                      </span>
                    )}
                  </div>
                </div>
                {showBtn ? (
                  <div className="ptur-turnoNoEncontrado-noEcontrados-contenedorBoton">
                    <button
                      className="ptur-turnoNoEncontrado-noEcontrados-boton rb18m"
                      onClick={onClickTurnos}
                    >
                      {txtBtn}
                    </button>
                  </div>
                ) : (
                  ""
                )}
              </div>
            ) : (
              ""
            )
          ) : (
            ""
          )}
        </>
      )}
    </>
  );
};

export default TurnoNoEncontrado;
